import type { IntlShape } from "react-intl";

export type AgentNoticeCode =
  | "web_search_unavailable"
  | "web_search_failed"
  | "pubmed_unavailable"
  // The user stopped the turn. Its own code, not a failure one: a failure is the assistant's and
  // invites "try again"; a stop is the user's own act, and the question stays in the thread to
  // build on.
  | "turn_stopped";

export function parseAgentNoticeCode(value: unknown): AgentNoticeCode | undefined {
  return value === "web_search_unavailable" ||
    value === "web_search_failed" ||
    value === "pubmed_unavailable" ||
    value === "turn_stopped"
    ? value
    : undefined;
}

export function agentNoticeMessage(intl: IntlShape, code: AgentNoticeCode): string {
  switch (code) {
    case "web_search_unavailable":
      return intl.formatMessage({
        id: "agent.webSearch.unavailable",
        defaultMessage: "Web search is unavailable or disabled for the current provider. No online search was performed. Turn off web search to search internally.",
      });
    case "web_search_failed":
      return intl.formatMessage({
        id: "agent.webSearch.failed",
        defaultMessage: "Web search could not be performed. Please try again.",
      });
    case "pubmed_unavailable":
      return intl.formatMessage({
        id: "agent.pubmed.unavailable",
        defaultMessage: "PubMed search is unavailable or disabled here. No PubMed search was performed. Turn off PubMed to answer without it.",
      });
    case "turn_stopped":
      return intl.formatMessage({
        id: "agent.turn.stopped",
        defaultMessage: "You stopped this answer. The question is still here: ask again, or refine it.",
      });
  }
}
